module.exports = __webpack_public_path__ + "img/s1-team5.6fa35545.jpg";